import { store } from 'v3/data/store';
import { groupsSlice } from 'v3/data/store/group';
import { groupsInitialState } from 'v3/data/store/group/state';
import { IGroup, IGroupsList } from 'v3/data/store/group/types';

export const setGroupName = (group: IGroup) => {
  store.dispatch(groupsSlice.actions.setGroupName(group));
};

export const setGroupList = (list: IGroupsList) => {
  store.dispatch(groupsSlice.actions.setGroupList(list));
};

export const setFilterCurrentPage = (value: number) => {
  store.dispatch(groupsSlice.actions.setFilterCurrentPage(value));
};

export const setFilterRowsPerPage = (value: number) => {
  store.dispatch(groupsSlice.actions.setFilterRowsPerPage(value));
};

export const setFilterGroupName = (name: string) => {
  store.dispatch(groupsSlice.actions.setFilterGroupName(name));
};

export const clearFilterGroup = () => {
  store.dispatch(groupsSlice.actions.setFilters(groupsInitialState.filter));
};
